import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function PageNotFound() {
  const {t} = useTranslation();

  return (
    <div className="app-body flex-grow-1 text-white d-flex flex-column justify-content-center my-5 py-5">
      <div className="container">
        <h1 className="text-white">{t("page_not_found.heading")}</h1>
        <p>{t("page_not_found.text")} <Link to="/">{t("page_not_found.link")}</Link></p>
      </div>
    </div>
  );
}